<div class="synthetic-sound" (click)="onClick()">
  

  <i class="material-icons">volume_down</i> {{ 'CONTEXTMENU.PRONOUNCE' | translate }}



</div>
